import axios from "axios"
import {defineStore} from "pinia"
import {ref} from "vue"

import {useFormDataStore} from "@/stores/FormDataStore"
import {usePaymentGatewaysStore} from "@/stores/PaymentGatewaysStore"
import {useHelpers} from "@/useHelpers"

const urlRemoveCartContent = 'forbes/cart/remove-cart'

export const useGiftStore = defineStore('GiftStore', () => {

	const { visitUrl } = useHelpers()
	const dataStore = useFormDataStore()
	const paymentGatewaysStore = usePaymentGatewaysStore()

	const payload = ref({})

	const buildUrlAddProductToCart = productId => `${window.api.baseUrl}/forbes/shop/tag/${productId}?do=addCart`

	const removeCartContent = async () => {
		return axios.get(`${window.api.baseUrl}${urlRemoveCartContent}`)
	}

	const addProductToCart = () => {
		const selectedProductId = dataStore.selectedSubscription.product.id
		const addProductToCartUrl = buildUrlAddProductToCart(selectedProductId)

		return axios.get(addProductToCartUrl)
	}

	const initPayload = () => {
		const invoiceAddress = dataStore.formData.invoiceAddress
		let address = {}
		if (dataStore.selectedSubscription.contentAccess.includes('print')) {
			address = dataStore.formData.address
		}

		const productData = {
			[`product_${dataStore.selectedSubscription.product.id}`]: {
				email: dataStore.formData.giftedEmail,
				date: dataStore.formData.giftedDateStart,
				address
			}
		}

		const paymentGateway = paymentGatewaysStore.getGatewayByCode(dataStore.formData.paymentGatewayCode)
		payload.value = {
			formData: {
				payment_gateway: paymentGateway.id,
				billing_address: invoiceAddress,
				...productData,
			}
		}

		console.log(payload.value)
	}

	const submit = async () => {
		initPayload()
		await initCart()

		const checkoutUrl = `products/shop/checkout/?payload=${btoa(JSON.stringify(payload.value))}`
		visitUrl(checkoutUrl)
	}

	const initCart = async () => {
		try {
			await removeCartContent()
		} catch (e) {
			console.warn(e)
		}
		await addProductToCart()
	}

	return {
		payload,
		initCart,
		initPayload,
		submit
	}
})